import * as runtime from '@/api/runtime'
import {
  BatchTrcBooksAndAvUpdateRequest,
  BatchTrcBooksAndAvUpdateRequestToJSON,
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api/models/batch'
import {
  BatchTrcBooksAndAvUpdateCondition,
  BatchTrcBooksAndAvUpdateConditionFromJSON
} from '@/api/models/batch/BatchTrcBooksAndAvUpdateCondition'

/**
 * 帳票作成
 */
export class BatchTrcBooksAndAvUpdateApi extends runtime.BaseAPI {
  async update(request: BatchTrcBooksAndAvUpdateRequest): Promise<number> {
    const response = await this.requestPost(
      `/batch/bibliography/update-trc-marc`,
      BatchTrcBooksAndAvUpdateRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async getInitialCondition(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchTrcBooksAndAvUpdateCondition> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchTrcBooksAndAvUpdateConditionFromJSON(jsonValue)
    ).value()
  }
}
